import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import stl from "./InfoComponent.module.css";
import { useTranslation } from "@i18n";
import Input from "@/components/UiKit/Input/Input";
import Select from "@/components/UiKit/Select/Select";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import { useLang } from "@/common/Contexts/LanguageContext";
import useButtonLoading, { dispatchButtonLoading } from "@hooks/useButtonLoading";
import Loader from "@componentsShared/Loader/Loader";
import { twMerge } from "tailwind-merge";
import useBoolean from "@hooks/useBoolean";
import InputCurrency from "@componentsShared/InputCurrency/InputCurrency";
import { If } from "@componentsShared/Conditional/If";
var WorkInfoComponent = function WorkInfoComponent(_ref) {
  var _workInfo$total_finan, _workInfo$total_finan2, _workInfo$traffic_fin, _workInfo$traffic_fin2;
  var g4Data = _ref.g4Data;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tLong = _useTranslation.tLong,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var liabilitiesRef = useRef(null);
  var trafficFinesRef = useRef(null);
  var trafficFineState = useBoolean();
  var _useAribFinance$state = useAribFinance().state,
    workInfo = _useAribFinance$state.workInfo,
    fetch_loading = _useAribFinance$state.fetch_loading;
  var post_id = useAribFinance().queryParams.post_id;
  var _useAribFinance$actio = useAribFinance().actions,
    action__updateWorkInfo = _useAribFinance$actio.action__updateWorkInfo,
    action__validateWorkInfo = _useAribFinance$actio.action__validateWorkInfo,
    action__updateOrderInfo = _useAribFinance$actio.action__updateOrderInfo,
    action__clearLocalStorageData = _useAribFinance$actio.action__clearLocalStorageData;
  var buttonLoading = useButtonLoading();
  var _useAribFinance$remot = useAribFinance().remote_actions,
    fetch__WorkSectorList = _useAribFinance$remot.fetch__WorkSectorList,
    fetch__BanksList = _useAribFinance$remot.fetch__BanksList,
    fetch__createAribJobForm = _useAribFinance$remot.fetch__createAribJobForm;
  var helper__getAribPaymentType = useAribFinance().helpers.helper__getAribPaymentType;
  var _useState = useState(null),
    errors = _useState[0],
    setErrors = _useState[1];
  var _useState2 = useState([]),
    workSectorOptions = _useState2[0],
    setWorkSectorOptions = _useState2[1];
  var _useState3 = useState([]),
    salaryTransfer = _useState3[0],
    setSalaryTransfer = _useState3[1];
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  useEffect(function () {
    fetch__WorkSectorList().then(function (workSectorArray) {
      setWorkSectorOptions(workSectorArray);
    });
    fetch__BanksList().then(function (bankList) {
      setSalaryTransfer(bankList);
    });
  }, []);
  var updateData = function updateData(key, value) {
    action__updateWorkInfo(_defineProperty({}, key, value));
  };
  var updateAllData = function updateAllData(newData) {
    action__updateWorkInfo(newData);
  };
  var updateErrors = function updateErrors(key, value) {
    setErrors(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
    });
  };
  var sendData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _response$data, _response$data2, _response$data3;
      var validationError, response, submission_source, eventPayload, _errors, _response$data4, _response$data6, _response$data7, _response$data8, _response$data9, _response$data5;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            validationError = action__validateWorkInfo();
            if (!(Object.keys(validationError).length > 0)) {
              _context.n = 1;
              break;
            }
            setErrors(validationError);
            return _context.a(2);
          case 1:
            dispatchButtonLoading(true);
            _context.n = 2;
            return fetch__createAribJobForm();
          case 2:
            response = _context.v;
            submission_source = getSubmissionSource();
            eventPayload = _objectSpread(_objectSpread({
              order_id: response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.order_id
            }, g4Data), {}, {
              salary: workInfo === null || workInfo === void 0 ? void 0 : workInfo.salary,
              inventory_type_string: g4Data === null || g4Data === void 0 ? void 0 : g4Data.inventory_type_string,
              salary_transfer: workInfo === null || workInfo === void 0 ? void 0 : workInfo.salary_transfer_method,
              post_trim: g4Data.post_ext,
              status: (workInfo === null || workInfo === void 0 ? void 0 : workInfo.salary_transfer_method) === "CASH" || (workInfo === null || workInfo === void 0 ? void 0 : workInfo.salary_transfer_method) === "CHECK" || (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.status) === 0 ? "rejected" : "accepted",
              referral_location: submission_source,
              finance_type: helper__getAribPaymentType(),
              fees: response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.amount
            });
            trackEvents("finance_form_submit", _objectSpread({}, eventPayload));
            if (!((response === null || response === void 0 ? void 0 : response.code) !== 200)) {
              _context.n = 3;
              break;
            }
            _errors = response.errors;
            setErrors(response.errors);
            dispatchButtonLoading(false);
            return _context.a(2, null);
          case 3:
            if (!response) {
              _context.n = 8;
              break;
            }
            dispatchButtonLoading(false);
            if (!((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.status) === 0)) {
              _context.n = 5;
              break;
            }
            if (!((response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.is_rejected_by_bank) === true)) {
              _context.n = 4;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 8
            }));
          case 4:
            action__clearLocalStorageData();
            return _context.a(2, navigateToHard("/finance/rejected?haveanotherOrder=1&post_id=" + post_id));
          case 5:
            action__updateOrderInfo({
              "order_id": response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.order_id
            });
            action__updateOrderInfo({
              "order_uuid": response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.order_uuid
            });
            if (!(response !== null && response !== void 0 && (_response$data8 = response.data) !== null && _response$data8 !== void 0 && _response$data8.payment_enabled && (response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.amount) > 0)) {
              _context.n = 6;
              break;
            }
            navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 10
            });
            _context.n = 7;
            break;
          case 6:
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 3
            }));
          case 7:
            _context.n = 9;
            break;
          case 8:
            dispatchButtonLoading(false);
          case 9:
            dispatchButtonLoading(false);
            return _context.a(2, null);
        }
      }, _callee);
    }));
    return function sendData() {
      return _ref2.apply(this, arguments);
    };
  }();

  // Define required fields for workInfo

  var requiredWorkFields = useMemo(function () {
    // Start with the base fields that are always required
    var fields = ["work_sector", "salary", "salary_transfer_method", "termsAccepted"];
    // If the work sector is one of these, add employer_name as a required field
    if (["BGOV", "PRVT", "UNEP", "SGOV"].includes(workInfo === null || workInfo === void 0 ? void 0 : workInfo.work_sector)) {
      fields.push("employer_name");
    }
    return fields;
  }, [workInfo === null || workInfo === void 0 ? void 0 : workInfo.work_sector]);
  var isButtonDisabled = requiredWorkFields.some(function (field) {
    var value = workInfo[field];
    return value === null || value === undefined || value === "";
  });
  var terms_and_Condition_HTML = function terms_and_Condition_HTML() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", {
      className: "text-[#3C56D4] text-center block text-2xl font-bold leading-8"
    }, t("terms_conditions_2", {
      ns: "web_checkout_finance"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[#3C56D4] text-[16px] text-center pb-5 mt-4 leading-8"
    }, tLong("arib_terms", {
      ns: "web_checkout_finance"
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-8 relative"
  }, /*#__PURE__*/React.createElement(Select, {
    className: "mb-[34px]",
    name: "work_sector",
    topLabel: t("employer", {
      ns: "web_checkout_finance"
    }),
    type: "select",
    error: errors ? errors.work_sector : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.work_sector) && updateErrors("work_sector", "");
    },
    onChange: function onChange(event) {
      updateData("work_sector", event.currentTarget.value);
    }
  }, !(workInfo !== null && workInfo !== void 0 && workInfo.work_sector) && /*#__PURE__*/React.createElement("option", {
    disabled: true,
    selected: true,
    hidden: true
  }, t("select", {
    ns: "web_checkout_finance"
  })), workSectorOptions.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      selected: (workInfo === null || workInfo === void 0 ? void 0 : workInfo.work_sector) === item.code,
      key: item === null || item === void 0 ? void 0 : item.code,
      value: item.code
    }, lang === "ar" ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.nameEn);
  })), ["BGOV", "PRVT", "UNEP", "SGOV"].includes(workInfo === null || workInfo === void 0 ? void 0 : workInfo.work_sector) && /*#__PURE__*/React.createElement(Input, {
    className: "mb-[34px]",
    name: "employer_name",
    label: t("workplace", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors.employer_name : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.employer_name) && updateErrors("employer_name", "");
    },
    onChange: function onChange(event) {
      updateData("employer_name", event.currentTarget.value);
    },
    maxLength: 200,
    value: workInfo["employer_name"]
  }), /*#__PURE__*/React.createElement("div", {
    className: "mb-8 flex gap-1 flex-col"
  }, /*#__PURE__*/React.createElement(InputCurrency, {
    inputClassName: "custom-input-class",
    defaultValue: workInfo["salary"],
    currencyLabel: workInfo["salary"] ? t("sar", {
      ns: "web_sell_trade"
    }) : "" // Currency label
    ,
    label: t("salary_without_additional_living_expenses", {
      ns: "web_checkout_finance"
    }) // Placeholder/Label
    ,
    lang: "en" // Language for formatting (en or ar)
    ,
    errorLabel: "" // Error message (if any)
    ,
    onChange: function onChange(value) {
      updateData("salary", value);
      updateErrors("salary", "");
    }
  }), /*#__PURE__*/React.createElement(If, {
    condition: errors === null || errors === void 0 ? void 0 : errors.salary
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#f71e1e] text-xs"
  }, errors === null || errors === void 0 ? void 0 : errors.salary))), /*#__PURE__*/React.createElement(Select, {
    className: "mb-[34px]",
    name: "salary_transfer_method",
    topLabel: t("how_transfer_salary", {
      ns: "web_checkout_finance"
    }),
    type: "select",
    error: errors ? errors.salary_transfer_method : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.salary_transfer_method) && updateErrors("salary_transfer_method", "");
    },
    onChange: function onChange(event) {
      updateData("salary_transfer_method", event.currentTarget.value);
    }
  }, !(workInfo !== null && workInfo !== void 0 && workInfo.salary_transfer_method) && /*#__PURE__*/React.createElement("option", {
    disabled: true,
    selected: true,
    hidden: true
  }, t("select", {
    ns: "web_checkout_finance"
  })), salaryTransfer.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      selected: (workInfo === null || workInfo === void 0 ? void 0 : workInfo.salary_transfer_method) === item.code,
      key: item === null || item === void 0 ? void 0 : item.code,
      value: item === null || item === void 0 ? void 0 : item.code
    }, lang === "ar" ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.nameEn);
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-base font-semibold text-neutral-100 text-start"
  }, tShort("arib/other_financial_liabilities_label", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-6 overflow-hidden"
  }, /*#__PURE__*/React.createElement(RadioInputItem, {
    text: tShort("arib/other_financial_liabilities1", {
      ns: "web_checkout_finance"
    }),
    id: "other_financial_liabilities1",
    type: "radio",
    name: "other_financial_liabilities_radio",
    value: "1",
    ref: liabilitiesRef,
    checked: workInfo["other_financial_liabilities"] === "1",
    onChange: function onChange(e) {
      updateData("other_financial_liabilities", e.target.value);
    }
  }), /*#__PURE__*/React.createElement(RadioInputItem, {
    text: tShort("arib/other_financial_liabilities2", {
      ns: "web_checkout_finance"
    }),
    id: "other_financial_liabilities2",
    type: "radio",
    name: "other_financial_liabilities_radio",
    value: "0",
    checked: workInfo["other_financial_liabilities"] === "0",
    onChange: function onChange(e) {
      updateData("other_financial_liabilities", e.target.value);
    }
  })), (errors === null || errors === void 0 ? void 0 : errors.other_financial_liabilities) && /*#__PURE__*/React.createElement("span", {
    className: "text-danger text-start text-xs font-regular"
  }, errors.other_financial_liabilities)), workInfo["other_financial_liabilities"] === "1" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_common"
    }),
    className: "w-full",
    name: "total_financial_liabilities",
    label: tShort("arib/other_financial_liabilities_placeholder", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors.total_financial_liabilities : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.total_financial_liabilities) && updateErrors("total_financial_liabilities", "");
    },
    onChange: function onChange(event) {
      updateData("total_financial_liabilities", event.currentTarget.value);
    },
    maxLength: 6,
    value: (_workInfo$total_finan = workInfo["total_financial_liabilities"].toString()) === null || _workInfo$total_finan === void 0 ? void 0 : (_workInfo$total_finan2 = _workInfo$total_finan.replace(/\D/g, "")) === null || _workInfo$total_finan2 === void 0 ? void 0 : _workInfo$total_finan2.replace(/\d(?=(\d{3})+(?!\d))/g, "$&,")
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-base font-semibold text-neutral-100 text-start"
  }, tShort("arib/traffic_fine_label", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-6 overflow-hidden"
  }, /*#__PURE__*/React.createElement(RadioInputItem, {
    text: tShort("arib/traffic_fine1", {
      ns: "web_checkout_finance"
    }),
    id: "traffic_fine1",
    type: "radio",
    ref: trafficFinesRef,
    name: "traffic_fine",
    value: "1",
    checked: workInfo["traffic_fine"] === "1",
    onChange: function onChange(e) {
      trafficFineState.setTrue();
      updateData("traffic_fine", e.currentTarget.value);
      updateErrors("traffic_fine", null);
    }
  }), /*#__PURE__*/React.createElement(RadioInputItem, {
    text: tShort("arib/traffic_fine2", {
      ns: "web_checkout_finance"
    }),
    id: "traffic_fine2",
    type: "radio",
    name: "traffic_fine",
    value: "0",
    checked: workInfo["traffic_fine"] === "0",
    onChange: function onChange(e) {
      trafficFineState.setFalse();
      updateData("traffic_fine", e.currentTarget.value);
    }
  })), (errors === null || errors === void 0 ? void 0 : errors.traffic_fine) && /*#__PURE__*/React.createElement("span", {
    className: "text-danger text-start text-xs font-regular"
  }, errors.traffic_fine)), workInfo["traffic_fine"] === "1" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_common"
    }),
    className: "w-full",
    name: "traffic_fine_value",
    label: tShort("arib/traffic_fine_placeholder", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors.traffic_fine_value : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.traffic_fine_value) && updateErrors("traffic_fine_value", "");
    },
    onChange: function onChange(event) {
      updateData("traffic_fine_value", event.currentTarget.value);
    },
    maxLength: 6,
    value: (_workInfo$traffic_fin = workInfo["traffic_fine_value"].toString()) === null || _workInfo$traffic_fin === void 0 ? void 0 : (_workInfo$traffic_fin2 = _workInfo$traffic_fin.replace(/\D/g, "")) === null || _workInfo$traffic_fin2 === void 0 ? void 0 : _workInfo$traffic_fin2.replace(/\d(?=(\d{3})+(?!\d))/g, "$&,")
  }))))), /*#__PURE__*/React.createElement("div", {
    className: stl.submitData
  }, /*#__PURE__*/React.createElement("button", {
    //className={["relative", !workInfo?.termsAccepted || isButtonDisabled ? "pointer-events-none !bg-gray-500 opacity-50 text-white" : buttonLoading ? "pointer-events-none bg-[#EBF0F7]" : "blueBtn bg-[#3C56D4]"].join(" ")}
    className: ["relative", buttonLoading ? "pointer-events-none bg-[#EBF0F7]" : "blueBtn bg-[#3C56D4]"].join(" "),
    onClick: sendData,
    disabled: fetch_loading
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-white"
  }, t("next_step", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", null), buttonLoading && /*#__PURE__*/React.createElement(Loader, {
    className: "!bg-transparent !absolute w-full h-full m-0 [zoom:0.6] [backdrop-filter:blur(1px)]"
  }))));
};
export default WorkInfoComponent;
var RadioInputItem = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var id = _ref3.id,
    type = _ref3.type,
    value = _ref3.value,
    checked = _ref3.checked,
    onChange = _ref3.onChange,
    name = _ref3.name,
    text = _ref3.text;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "text-neutral-100 text-base font-regular cursor-pointer flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    type: type,
    name: name,
    value: value,
    checked: checked,
    onChange: onChange,
    ref: ref,
    className: "sr-only"
  }), /*#__PURE__*/React.createElement("div", {
    className: twMerge('w-6 h-6 rounded-full border flex items-center justify-center transition-all border-primary border-solid flex-shrink-0')
  }, checked && /*#__PURE__*/React.createElement("div", {
    className: "w-3 h-3 rounded-full bg-primary"
  })), text);
});